//== ********************************
//== Feature Modal (work in progress)
//== ********************************

const btnModalOpen = document.querySelectorAll('.btn-modal')

// Loop through all elements with the class name "btn-modal"
for (let i = 0; i < btnModalOpen.length; i++) {
  btnModalOpen[i].addEventListener('click', function () {
    const modalID = this.dataset.modalid
    const modalURL = this.dataset.modaliframe

    if (modalID) {
      const pnlModal = document.getElementById(`${modalID}`)
      handleOpenOnPageModal(pnlModal, btnModalOpen[i])
      trapTabKey(pnlModal)
    }

    if (modalURL) {
      handleOpenVideoModal(modalURL)
    }
  })
}

// Select all elements with the class 'btn-modal-close'
const btnModalClose = document.querySelectorAll('.btn-modal-close')

for (let i = 0; i < btnModalClose.length; i++) {
  btnModalClose[i].addEventListener('click', function () {
    closeFeatureModal()
  })
}

const closeFeatureModal = (e) => {
  const pnlModalclose = document.querySelectorAll('.feature-modal.is-open')
  if (pnlModalclose.length > 0) {
    for (let i = 0; i < pnlModalclose.length; i++) {
      pnlModalclose[i].classList.remove('is-open')
      //pnlModalclose[i].setAttribute('aria-hidden', 'true')
      pnlModalclose[i].classList.add('is-closing')
      setTimeout(() => {
        pnlModalclose[i].classList.remove('is-closing')
        document.body.classList.remove('oflow')
      }, 300)
    }
    for (let j = 0; j < btnModalOpen.length; j++) {
      btnModalOpen[j].setAttribute('aria-expanded', 'false')
    }
    releaseTabKey()
  }
}

const closeVideoModal = (_modal) => {
  _modal.classList.add('is-closing')
  setTimeout(() => {
    _modal.remove()
    document.body.classList.remove('oflow')
  }, 300)
}

const createElementClass = (_elName, _classList) => {
  let newElement = document.createElement(_elName)
  newElement.classList = _classList
  return newElement
}

//== prep the URL for embedding
function fixVideoURL(_urlText) {
  let returnVal = _urlText
  //== youtube
  if (_urlText.includes('youtube.com')) {
    let regYT = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/ ]{11})/i
    returnVal = _urlText.replace(regYT, 'youtube.com/embed/$1?autoplay=1')
  }
  //== vimeo
  if (_urlText.includes('vimeo.com')) {
    let regVim = /vimeo.*(?:\/|clip_id=)([0-9a-z]*)/i
    returnVal = '//player.vimeo.com/video/' + _urlText.match(regVim)[1]
  }
  return returnVal
}

const handleOpenOnPageModal = (_pnlModal, _btnModal) => {
  _pnlModal.classList.add('is-open')
  // _pnlModal.setAttribute('aria-hidden', 'false')
  _btnModal.setAttribute('aria-expanded', 'true')
  _pnlModal.addEventListener('click', function (e) {
    if (e.target.classList.contains('is-open')) {
      closeFeatureModal()
    }
  })

  document.body.classList.add('oflow')
}

const handleOpenVideoModal = (_modalURL) => {
  //== create modal block and content
  let mModal = createElementClass('div', 'feature-modal is-video is-open')
  let mContent = createElementClass('div', 'modal-content')

  //== create iframe to embed the video for content
  let mFrame = createElementClass('iframe', 'modal-video')
  mFrame.src = fixVideoURL(_modalURL.replace('https://', '//'))
  mFrame.frameBorder = 0
  mFrame.setAttribute('allowfullscreen', '')

  //== create close button for content
  let mClose = createElementClass('button', 'btn-modal-close')
  mClose.innerHTML = '×'
  mClose.setAttribute('type', 'button')
  mClose.addEventListener('click', function () {
    closeVideoModal(mModal)
  })

  //== add close and iframe to content
  mContent.appendChild(mClose)
  mContent.appendChild(mFrame)

  //== add content to modal
  mModal.appendChild(mContent)
  //mModal.setAttribute('aria-hidden', false)
  mModal.addEventListener('click', function (e) {
    if (e.target.classList.contains('is-open')) {
      closeVideoModal(mModal)
    }
  })

  //== add the modal block to the body
  document.body.appendChild(mModal)
  document.body.classList.add('oflow')
}

// KEYTRAPPING

let activeModal

function trapTabKey(modal) {
  activeModal = modal

  // focusable elements, but exclude hidden elements (display:none, visibility:hidden, or hidden via ancestor)
  let focusableElements = Array.from(
    modal.querySelectorAll('a, button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
  ).filter((el) => {
    return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length)
  })

  const firstFocusable = focusableElements[0]
  const lastFocusable = focusableElements[focusableElements.length - 1]

  modal.addEventListener('keydown', function (e) {
    if (e.key === 'Tab') {
      if (e.shiftKey) {
        if (document.activeElement === firstFocusable) {
          e.preventDefault()
          lastFocusable.focus()
        }
      } else {
        if (document.activeElement === lastFocusable) {
          e.preventDefault()
          firstFocusable.focus()
        }
      }
    }
  })

  // Focus the first element when the modal opens
  firstFocusable.focus()

  if (modal.id === 'searchModal') {
    const searchInput = document.getElementById('searchField')
    if (searchInput) searchInput.focus()
  }
}

function releaseTabKey() {
  activeModal.removeEventListener('keydown', trapTabKey)
}

// TESTING DIALOG

// const dialog = document.querySelector('dialog')
// const buttonOpen = document.querySelector('.open-dialog')
// const buttonClose = document.querySelector('.close-dialog')

// buttonOpen.addEventListener('click', function () {
//   dialog.showModal()
// })

// buttonClose.addEventListener('click', function () {
//   dialog.close()
// })
